import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BtnGoBack from "../../../components/common/btnGoBack";
import ShowDoc from "../../../components/common/showDoc";
import BtnSendDoc5 from "../../../components/send/doc3/btnSendDoc5";
import HeadderSend from "../../../components/send/headderSend";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import doc5Service from "../../../services/doc5.service";
import scheduleService from "../../../services/schedule.service";
const CourseContext = React.createContext({});
const Doc5 = () => {
  const location: any = useLocation();
  const { curri, schedule, doc3Id, course, teacher, doc5 } = location.state;
  // const me = useSelector((state: any) => state.me);

  const [doc5List, setDoc5List] = useState([]);

  const user = JSON.parse(localStorage.getItem("user") ?? "false");

  useEffect(() => {
    (async () => {
      await doc5Service.getByDoc3(doc3Id).then((res: any) => {
        setDoc5List(res.data);
      });
    })();
  }, [doc3Id, schedule]);
  const [btnDoc5, setBtnDoc5] = useState(false);

  useEffect(() => {
    (async () => {
      await scheduleService.getById(Number(schedule)).then((res) => {
        // const DateDoc3 = new Date(res.data.doc3);
        const DateDoc5 = new Date(res.data.doc5).setHours(0, 0, 0, 0);
        const toDay = new Date().setHours(0, 0, 0, 0);
        // console.log("to Day", toDay);
        // console.log("Date For Doc5", toDay);
        // console.log(DateDoc5);

        if (toDay >= DateDoc5) {
          setBtnDoc5(true);
        }

        // console.log(toDay <= DateDoc3);
      });
    })();
  }, [schedule]);

  return (
    <CourseContext.Provider value={{ doc5List, setDoc5List }}>
      <HeadderSend scheId={schedule}>
        <div className="alert alert-light text-dark" role="alert">
          <div className="row">
            <div className="col text-start">
              <h5>
                หลักสูตร {curri.shortName} - {curri.name} ({curri.level})
              </h5>
              <p>
                รายวิชา ({course.course.courseCode}) {course.course.name}
              </p>
            </div>
          </div>
          <hr />
          <table className="table table-hover table-responsive">
            <thead className="table-dark">
              <tr>
                <th>กลุ่มเรียน</th>
                <th>อาจารย์ผู้สอน</th>
                <th>Handle</th>
              </tr>
            </thead>
            <tbody>
              {!(doc5List.length > 0) && (
                <tr>
                  <th colSpan={4} className="text-danger">
                    <i className="bi bi-folder-x"></i> ไม่พบการส่งเอกสาร{" "}
                    {curri.type === "tqf" ? "มคอ." : "อชว."}5
                  </th>
                </tr>
              )}
              {doc5List.map((doc5: any) => {
                // console.log(doc5.pathFile);

                return (
                  <tr key={doc5.id}>
                    <td>{doc5.group}</td>
                    <td>{doc5.teacher}</td>
                    <td>
                      <ShowDoc
                        btnName={`${curri.type === "tqf" ? "มคอ." : "อชว."}5`}
                        url={`${BaseURL.BASE_URL}/upload/doc5/${doc5.pathFile}`}
                      />{" "}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {user.role.name === "Member" && (
            <div className="row justify-content-md-center">
              <div className="col col-2">
                {btnDoc5 && (
                  <BtnSendDoc5
                    schedule={schedule}
                    curri={curri}
                    course={course}
                    teacher={teacher}
                    doc5={doc5}
                    doc3Id={doc3Id}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <BtnGoBack />
      </HeadderSend>
    </CourseContext.Provider>
  );
};
export { CourseContext };
export default Doc5;
